<template>
  <div>
  <label>{{termConf.name}}</label>
  <table class="table table-bordered">
      <thead>
        <tr>
          <td class="text-center">Subject Name/Paper Name</td>
          <td class="text-center">Maximum Mark/CGPA</td>
          <td class="text-center">Mark/CGPA Obtained</td>
          <td class="text-center" v-if="markentryConf.termConf.cognateFieldEnabled">Please tick if it is cognate subject</td>
          <td class="text-center" v-if="markentryConf.termConf.isLanguageFieldEnabled">Please tick if it is language</td>
        </tr>
      </thead>
      <tbody>
            <template v-for="subjectNo in markentryConf.termConf.numberOfSubjects">
                <singleTermWiseMarkentryRow :subject-no="subjectNo" :markentry-conf="markentryConf" :key="subjectNo" @add-mark="setMark"></singleTermWiseMarkentryRow>
            </template>
      </tbody>
  </table>
  </div>
</template>

<script>
import singleTermWiseMarkentryRow from "./singleTermMarkentryRow.vue";

export default {
 name: "single-termwise-markentry",
 components:{
     singleTermWiseMarkentryRow
 },
 props:{
     markentryConf:Object,
     termConf:Object
 },
 data(){
     return {
         termMark:[]
     }
 },
 methods:{
     setMark(response){
        this.termMark[response.subjectNo]=response.mark;
     }
 },
 watch:{
     termMark(){
         const termMarkObject={};
         termMarkObject.term=this.termConf.id;
         termMarkObject.markList=this.termMark;
         this.$emit('add-term-mark',termMarkObject);
     }
 }
}
</script>

<style>

</style>